import type { ReactNode } from "react";
import { Dialog as AriaDialog, Heading, Modal, ModalOverlay } from "react-aria-components";
import { useGestaltung } from "./gestaltung";
import { useSperre } from "./sperre";
import { Symbol } from "./Symbol";

/**
 * Dialog (`dialog`) für Formulare bzw. Bestätigung (`alertdialog`) mit dem Namen der Handlung (oberflaeche.md §1.2).
 * Fokusfalle und Escape von React Aria; 500 ms Eingabesperre beim Öffnen (design/README §9.5). Der Dialog liegt außerhalb
 * der Ansicht und wird deshalb selbst gestaltet (Wortbreiten der Kacheln, Bericht B4 F8).
 */
export function Dialog({ name, titel, symbol, offen, onSchliessen, bestaetigung, children }: {
  name: string;
  /** sichtbarer Titel, wenn er vom Namen abweicht (z. B. mit weichem Trennstrich an der Wortfuge, design/README K96) */
  titel?: string;
  symbol?: string; offen: boolean; onSchliessen: () => void; bestaetigung?: boolean; children: ReactNode;
}) {
  const gesperrt = useSperre("kritisch", offen, offen);
  const wurzel = useGestaltung();
  return (
    <ModalOverlay className="ueberlagerung" isOpen={offen} onOpenChange={(o) => { if (!o) onSchliessen(); }} isDismissable={!bestaetigung}>
      <Modal className="ueberlagerung__blatt">
        <AriaDialog ref={wurzel} className="blattdialog" role={bestaetigung ? "alertdialog" : "dialog"} aria-label={name} inert={gesperrt} aria-busy={gesperrt || undefined}>
          <Heading slot="title">{symbol ? <Symbol name={symbol} /> : null}<span>{titel ?? name}</span></Heading>
          {children}
        </AriaDialog>
      </Modal>
    </ModalOverlay>
  );
}
